import { Position } from "reactflow";
import { INodeData } from "../../index";
import { Box } from "@mui/material";
import CustomHandler from "../../Helpers/CustomHandler";

export default function NodeCondicional({ data }: INodeData) {
    return (
        <Box position="relative">
            <CustomHandler type="target" id="target-left" position={Position.Left} />
            <Box
                bgcolor="#6c757d"
                border={`2px solid rgba(0,0,0, ${data.isClicked ? "0.7" : "0.2"})`}
                height={100}
                width={100}
                display="flex"
                alignItems="center"
                justifyContent="center"
                margin="20px"
                sx={{
                    transform: 'rotate(45deg)'
                }}
            >
                <Box
                    sx={{
                        transform: 'rotate(-45deg)',
                        textAlign: 'center',
                        fontSize: 12,
                        color: "white"
                    }}
                >
                    {data.titulo}
                </Box>
            </Box>
            <CustomHandler type="source" id="source-top" position={Position.Top} />
            <CustomHandler type="source" id="source-right" position={Position.Right} /> 
            <CustomHandler type="source" id="source-bottom" position={Position.Bottom} />
        </Box>
    )
}
